export default __webpack_public_path__ + "static/media/fbank-indices.24d67df7.jpg";